import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Back.scss';

type BackProps = {
  backTo?: string;
  label?: string;
};

export default function Back({ backTo, label = 'Back' }: BackProps) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Link
      to=""
      onClick={(e) => {
        // `preventDefault` is required to stop react router from attempting to navigate to '' (the `to` prop)
        // which breaks this back button if there are search params in the url.
        e.preventDefault();

        if (backTo) {
          navigate(backTo, { replace: true });
          return;
        }

        if (location.key !== 'default') {
          navigate(-1);
          return;
        }

        navigate('/');
      }}
      className="nhsuk-back-link"
    >
      <div className="nhsuk-back-link__link">{label}</div>
    </Link>
  );
}
